import { render, staticRenderFns } from "./LoyaltyStampGift.vue?vue&type=template&id=33d38062&scoped=true&lang=pug&"
import script from "./LoyaltyStampGift.vue?vue&type=script&lang=js&"
export * from "./LoyaltyStampGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d38062",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
